import React from "react"
import { chakra, Flex } from "@chakra-ui/react"
import { BackgroundSlice } from "./"

export function FeaturedSection({ children, ...rest }) {
  return (
    <chakra.section {...rest}>
      <BackgroundSlice />
      <Flex
        bg="base.d100"
        sx={{
          "> * ": {
            position: "relative",
            zIndex: 2,
          },
        }}
      >
        {children}
      </Flex>
      <BackgroundSlice reverse />
    </chakra.section>
  )
}
